define([
	"dojo/_base/declare",
	"csi/comm",
	"csi/config",
	"csi/locale",
	"csi/xml",
	"csi/table/Delete",
], function(declare, comm, config, locale, xml, DeleteController) {

	return declare(DeleteController, {
		_bDeletePM: false,
		hasPMsToDelete: false,

		/**
		 * @override
		 * Query for part materials as they are needed to determine confirmation message
		 */
		_preActionRequests: function(requests) {
			requests.push(comm.getNodeRequest(this.m_urlParent).addDependencyPaths(["Child:Items"]));
			this.inherited(arguments);
		},

		/**
		 * Confirmation is needed when the user attempts to unfreeze the row.
		 */
		hasToConfirmAction: function() {
			return true;
		},

		/**
		 * @override
		 * Prompt confirmation with buttons “Remove” and "Keep PartMaterials" and “Cancel”.
		 * @param {Object} params
		 */
		confirmAction(params) {
			let message;
			const thisNode = this.getNode();
			const subtype = this.m_cache.getPathNode(this.m_urlParent, "Child:__Parent__").Subtype;
			const locked = config.getSubtypeSetting(subtype, "LockThemePlacementList") || false;
			const isSize = thisNode.$Type == "ProductSize";
			const isColor = thisNode.$Type == "Colorway" || thisNode.$Type == "ColorMaterial";
			let titleKey = "Delete_Title";

			if (isSize || isColor) {
				message = locale.typeAction("ProductBOMRevision", (isSize ? "Delete_Confirm_ProductSize" : "Delete_Confirm_ProductColor"));
				titleKey = isSize ? "Delete_Title_ProductSize" : "Delete_Title_ProductColor";

				const partMaterials = this.m_cache.getNodes(this.m_cache.getNode(this.m_urlParent).Items);
				// see if any PartMaterials have only this Color/Size in OnlyForColors/Sizes and BOM is not LockThemePlacementList where PartMaterial is linked
				let affectedPMs = "";
				partMaterials.forEach(function(pm) {
					const pmOnlyForX = isSize ? pm.OnlyForSizes : pm.OnlyForColors;
					if (pmOnlyForX.length == 1 && pmOnlyForX[0] == thisNode.$URL && !(locked && xml.isValidURL(pm.FromMaterialPlanPlacement))) {
						if (affectedPMs != "") {
							affectedPMs += ", ";
						}
						affectedPMs += "\"" + pm.$Name + "\"";
					}
				});
				this.hasPMsToDelete = false;
				if (affectedPMs != "") {
					message += "\n" + locale.typeAction("ProductBOMRevision", isSize ? "Delete_Confirm_OnlyForSizes" : "Delete_Confirm_OnlyForColors", [affectedPMs]);
					this.hasPMsToDelete = true;
				}
			}

			this._confirm(locale.typeAction("ProductBOMRevision", titleKey), message);
		},

		/**
		 * Set Confirm action text
		 * @param {String} titleKey
		 * @param {String} messageKey
		 */
		_confirm(titleKey, messageKey) {
			const buttons = this.hasPMsToDelete ? ["REMOVE", "KEEP_PMS", "C"] : ["REMOVE", "C"];
			DeleteController.prototype.confirmAction.call(this, {
				title: titleKey,
				message: messageKey,
				buttons: buttons
			});
		},

		onConfirm: function(key) {
			if (key == "KEEP_PMS") {
				this._bDeletePM = false;
				this.process();
			} else if (key == "REMOVE") {
				this._bDeletePM = true;
				this.process();
			} else {
				this.postProcess();
			}
		},

		toWriterRequest: function() {
			// summary: add deletePM boolean parameter to request
			return this.inherited(arguments).addParameter("DeletePlacements", xml.ATTR_BOOLEAN, this._bDeletePM);
		},
	});
});